//Fix everywhere with refactor

import { ButtonSize, ButtonStyle } from '@/app/components/Button/Button';
import { useIsIosOs } from '@/app/providers/ConfigProvider';
import classNames from 'classnames';

type ButtonOnlyProps = {
  testId: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  size?: ButtonSize;
  style?: ButtonStyle;
  children?: React.ReactNode;
};

// With refactor update button component and split it to button and link
export const ButtonOnly = ({
  testId,
  type = 'button',
  disabled,
  onClick,
  className,
  size,
  style,
  children,
}: ButtonOnlyProps) => {
  const isIosOs = useIsIosOs();

  const iosActiveStyles = {
    'active:bg-primary-dark': style === ButtonStyle.PRIMARY,
    'active:border-primary-mid': style === ButtonStyle.PRIMARY_OUTLINED && disabled,
    'active:bg-primary-light': style === ButtonStyle.PRIMARY_OUTLINED && !disabled,
    'active:border-success-mid': style === ButtonStyle.SUCCESS_OUTLINED,
    'active:bg-success-light': style === ButtonStyle.SUCCESS_OUTLINED,
    'active:bg-social-facebook-dark': style === ButtonStyle.FACEBOOK,
    'active:bg-social-x-light': style === ButtonStyle.X,
    'active:bg-social-whatsapp-dark': style === ButtonStyle.WHATSAPP,
  };

  const otherPlatformsStyles = {
    'hover:bg-primary-dark': style === ButtonStyle.PRIMARY,
    'hover:border-primary-mid': style === ButtonStyle.PRIMARY_OUTLINED && !disabled,
    'hover:bg-primary-light': style === ButtonStyle.PRIMARY_OUTLINED && !disabled,
    'hover:border-success-mid': style === ButtonStyle.SUCCESS_OUTLINED,
    'hover:bg-success-light': style === ButtonStyle.SUCCESS_OUTLINED,
    'hover:bg-social-facebook-dark': style === ButtonStyle.FACEBOOK,
    'hover:bg-social-x-light': style === ButtonStyle.X,
    'hover:bg-social-whatsapp-dark': style === ButtonStyle.WHATSAPP,
  };

  const activeStyles = isIosOs ? iosActiveStyles : otherPlatformsStyles;

  return (
    <button
      className={classNames(
        className,
        'rounded-[4px] font-medium tracking-[2px] uppercase transition-colors cursor-pointer',
        {
          'px-[16px] py-[12px] text-[12px] leading-[16px]': size === ButtonSize.MEDIUM,
          'px-[24px] py-[20px] text-[12px]': size === ButtonSize.LARGE,
          'px-[24px] py-[24px] text-[14px]': size === ButtonSize.XL,
          'bg-primary-mid text-white': style === ButtonStyle.PRIMARY,
          'text-primary-mid border-2 border-primary-light bg-white': style === ButtonStyle.PRIMARY_OUTLINED,
          'text-success-mid border-2 border-success-midLight bg-white': style === ButtonStyle.SUCCESS_OUTLINED,
          'text-primary-mid bg-transparent': style === ButtonStyle.PRIMARY_LINK,
          'text-neutral-dark bg-transparent': style === ButtonStyle.NEUTRAL_LINK,
          'opacity-50 cursor-default': disabled,
          'cursor-pointer': !disabled,
          'bg-social-facebook-light text-white': style === ButtonStyle.FACEBOOK,
          'bg-social-x-dark text-white': style === ButtonStyle.X,
          'text-white bg-instagramGradient': style === ButtonStyle.INSTAGRAM,
          'bg-social-whatsapp-light text-white': style === ButtonStyle.WHATSAPP,
          ...activeStyles,
        },
      )}
      data-testid={testId}
      type={type}
      onMouseDown={(e) => e.preventDefault()}
      // we dont want to trigger onClick of parent element
      onClick={(ev) => {
        ev.stopPropagation();
        onClick?.();
      }}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
